import { Controller } from "@hotwired/stimulus"
import debounced from 'debounced'

export default class extends Controller {
  static targets = [
    'input',
    'results'
  ]

  static values = {
    url: String
  }

  connect() {
    debounced.initialize(['input'], { wait: 300 })
    window.addEventListener('click', (e) => {
      if (this.resultsTarget.contains(e.target)) { return }
      
      this.resultsTarget.classList.remove('open')
    })
  }

  async search() {
    const url = this.urlValue + `?name=${this.inputTarget.value}`
    let response = await fetch(url)
    let results = await response.text()

    if (response.status == 200) {
      this.resultsTarget.innerHTML = null
      this.resultsTarget.classList.add('open')
      this.resultsTarget.innerHTML =  results
    }
  }

  set(e) {
    this.inputTarget.value = e.target.innerText
    this.resultsTarget.classList.remove('open')
  }

}
